<template>
  <div>
    <v-layout row wrap>
      <v-flex xs12 sm2 pt-2 hidden-xs-only>
        <div class="fixed-celebration-buttons">
          <v-btn
            depressed
            v-for="category in categories"
            :key="category.value"
            color="white"
            block
            :class="category.value === selectedCategory ? 'btn-selected' : 'btn-primary-security text-14-security'"
            @click="changeCategory(category.value)"
          >{{ category.name }}</v-btn>
        </div>
      </v-flex>

      <v-flex xs12 hidden-sm-and-up mt-4 class="select-category px-2">
        <v-select
          :items="categories"
          v-model="selectedCategory"
          label="Categoría"
          solo
          item-text="name"
          item-value="value"
          hide-details
          outline
        ></v-select>
      </v-flex>

      <v-flex xs12 :class="{'sm10 pl-4': $vuetify.breakpoint.smAndUp}">
        <v-flex xs12 sm12 scroll-y id="scroll-target" style="max-height: 900px">
          <PostsInfinite :type="type" :category="selectedCategory" :key="selectedCategory" />
        </v-flex>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import PostsInfinite from './PostsInfinite.vue';
import { mapActions } from 'vuex';

export default {
  props: {
    type: {
      type: String,
      required: true 
    }
  },
  components: {
    PostsInfinite
  },
  data() {
    return {
      selectedCategory: 'Todos',
      protagonistLinks: [],
      fetchedCategories: []
    };
  },
  methods: {
    ...mapActions("protagonists", ["fetchProtagonistLink"]),
    changeCategory(cat) {
      this.selectedCategory = cat;
      const selectedLink = this.protagonistLinks.find(link => link.title === cat);
      if (selectedLink) {
        window.open(selectedLink.url, "_self");
      }
    },
    async getProtagonistsLink() {
      const res = await this.fetchProtagonistLink(this.$route.name);
      this.protagonistLinks = res;
      this.fetchedCategories = res.map(link => ({
        name: link.title,
        value: link.title
      }));
    }
  },
  computed: {
    categories() {
      let baseCategories = [];

      if (this.type === 'protagonists') {
        baseCategories = [
          { name: "Todos", value: "Todos" },
          { name: "Conoce a", value: "Conociéndonos" },
          { name: "Testimonios", value: "Testimonios" },
          { name: "Lado B", value: "Lado B" },
          { name: "Tengo un dato", value: "Tengo un dato" }
        ];
      } else if (this.type === 'Huella Security') {
        baseCategories = [
          { name: "Todos", value: "Todos" },
          { name: "Qué es la Huella", value: "Qué es la Huella" },
          { name: "Voluntarios Security", value: "Voluntarios Security" },
          { name: "Reciclaje Security", value: "Reciclaje Security" },
          { name: "¡Ayuda ya!", value: "¡Ayuda ya!" }
        ];
      } else if (this.type === 'Proceso Integracion') {
        baseCategories = [
          { name: "Todos", value: "Todos" },
          { name: "Noticias", value: "Noticias Proceso Integración" },
          { name: "Q&A", value: "Preguntas y Respuestas Proceso Integración" }
        ];
      } else if (this.type === 'Programa Líderes que Inspiran') {
        baseCategories = [
          { name: "Información del Programa", value: "Información del Programa" },
          { name: "Material y Herramientas", value: "Material y Herramientas" },
          { name: "Fotos y Videos", value: "Fotos y Videos" },
          { name: "Juntas Somos+", value: "Juntas Somos+" }
        ];
      }

      const combinedCategories = [
        ...baseCategories,
        ...this.fetchedCategories
      ];

      // Get rid of duplicates if they exist
      const uniqueCategoriesMap = new Map();
      combinedCategories.forEach(cat => {
        const normalizedValue = cat.value.trim().toLowerCase();
        if (!uniqueCategoriesMap.has(normalizedValue)) {
          uniqueCategoriesMap.set(normalizedValue, cat);
        }
      });

      const uniqueCategories = Array.from(uniqueCategoriesMap.values());

      // Add field TODOS at the end of the list if it doesn't exist
      const todosCategory = { name: "Todos", value: "Todos" };
      if (!uniqueCategories.some(cat => cat.value === 'Todos')) {
        uniqueCategories.push(todosCategory);
      }

      this.selectedCategory = uniqueCategories[0].value;

      return uniqueCategories;
    }
  },
  created() {
    this.getProtagonistsLink();
  }
};
</script>

<style scoped>
.btn-selected {
  background: #28385C !important; 
  border-color: #28385C !important; 
  color: white; 
  font-weight: 700;
  font-size: 14px;
  border-radius: 8px;
  padding: 0px 46.5px;
  height: 30px;
}
</style>
